import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './invoices.constants';
import * as types from './invoices.types';
import * as services from './invoices.saga-services';

function* invokeFetchInvoices(action: types.IFetchInvoices) {
  yield call(services.fetchInvoices, action.payload);
}

function* invokeFetchInvoiceDetail(action: types.IFetchInvoiceDetail) {
  yield call(services.fetchInvoiceDetail, action.payload);
}

export function* watchInvoicesPageSaga() {
  yield takeLatest(constants.FETCH_INVOICES, invokeFetchInvoices);
  yield takeLatest(constants.FETCH_INVOICE_DETAIL, invokeFetchInvoiceDetail);
}
